/** The wall: the Workspace gallery of cards, Pinned tools and new arrivals. */
export default {
  showOnBoard: "Show on board",
  showInMemory: "Show in memory",

  // Header
  searchProject: "Search {project}…",
  searchThisProject: "Search this project…",
  searchEverything: "Search everything…",
  searchArchived: "Search archived…",
  unreadNotifications: {
    one: "{count} unread notification",
    other: "{count} unread notifications",
  },
  noNotificationsMatch: "No notifications match this search.",
  showingScope: "Showing {scope}",
  everything: "Everything",
  project: "Project",
  backToProject: "Back to the project",
  addToWall: "Add to the wall",
  add: "Add",
  newNote: "New note",
  pasteAsNote: "Paste as note",
  newTerminal: "New terminal",
  addFiles: "Add files…",
  orDropOnWall: "or drop on the wall",
  fileTooLarge: "{name} is larger than {max}",
  fileEmpty: "{name} is empty",
  fileUploadFailed: "Couldn’t add {name}",
  folderSkipped: "{name} is a folder, so it was skipped",
  newCount: "New {count}",

  // Pinned
  bookmarks: "Bookmarks",
  allChats: "All chats",
  noChatsYet: "No chats yet",
  noChatsMatch: "No chats match “{query}”.",
  newQuickNote: "New quick note",
  startTyping: "Start typing here…",
  quickNoteSaveHint: "{shortcut} or click away saves",

  // Feed
  emptySearchEverything: "Nothing matches that search.",
  emptySearchProject: "Nothing matches that search in this project.",
  emptyArchived: "Nothing is archived.",
  emptyWall: "Nothing here yet. What you and your agents make appears here.",
  cardsDidNotLoad: "These cards didn't load.",

  // Cards and their menus
  openItem: "Open {title}",
  openItemSelected: "Open {title}, selected",
  selected: "selected",
  bookmark: "Bookmark",
  removeBookmark: "Remove bookmark",
  focus: "Focus",
  pinToDesktop: "Pin to desktop",
  unpinFromDesktop: "Unpin from desktop",
  widgetSize: "Size",
  widgetSmall: "Small",
  widgetMedium: "Medium",
  widgetLarge: "Large",
  unarchive: "Unarchive",
  download: "Download",
  downloadItem: "Download…",
  deleteItemTitle: "Delete this item?",
  deleteItemBody:
    "It is deleted for good. Archive takes it off the wall and keeps it.",
  deleteItemsTitle: {
    one: "Delete {count} item?",
    other: "Delete {count} items?",
  },
  deleteItemsBody:
    "They are deleted for good. Archive takes them off the wall and keeps them.",
  newTask: "New task",
  newTaskLabel: "New task: {title}",
  denkerLearnedLabel: "Denker learned: {name}",
  hideFromWall: "Hide",
} as const;
